import { Injectable } from "@angular/core";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { environment } from "src/environments/environment";

(window as Window)["Pusher"] = Pusher;

@Injectable({
  providedIn: "root",
})
export class SocketService {
  private static echoInstance: Echo<any> | null = null;

  wsHost = `${environment.serverUrl}`;
  wsKey = `${environment.wsKey}`;

  constructor() {
    if (!SocketService.echoInstance) {
      SocketService.echoInstance = this.initWebSocket();
    }
  }

  public getSocketInstance(): Echo<any> {
    return SocketService.echoInstance!;
  }

  private initWebSocket(): Echo<any> {
    const { production } = environment;

    return new Echo({
      broadcaster: "pusher",
      cluster: "mt1",
      key: this.wsKey,
      wsHost: this.wsHost,
      forceTLS: production,
      disableStats: true,
      enabledTransports: ["ws", "wss"],
    });
  }
}
